import { defineComponent, watch, reactive } from 'vue'
import { pick, debounce } from 'lodash-es'
import { genCustomId } from '@/utils/basic'
import './index.scss'
import $FormDialogServer from '@/components/FormDialog'

export default defineComponent({
  name: 'ColumnInput',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },
  emits: ['update:value'],
  setup(props, ctx) {
    const state = reactive({
      dataModel: props.value.map((item) => ({ ...item, _id: genCustomId() }))
    })
    const keys = props.value.length ? Object.keys(props.value[0]) : []

    const methods = {
      updateChange: debounce(function (newVal) {
        const list = newVal.map((item) => pick(item, keys))
        ctx.emit('update:value', list)
      }, 900),
      genNewColumn(label) {
        return {
          prop: '',
          label: label || '新增项',
          _id: genCustomId()
        }
      }
    }

    const editFields = [
      {
        label: '列的名称',
        key: 'label',
        type: 'input'
      },
      {
        label: '列绑定的key', // 列绑定的 key 只能从 Object.keys(rowData) 中选择
        key: 'prop',
        type: 'select',
        options: props.value.map(({ prop }) => ({ value: prop, label: prop }))
      },
      {
        label: '列的宽度',
        key: 'width',
        type: 'number'
      },
      {
        label: '列对齐方式',
        key: 'align',
        type: 'select',
        options: [
          {
            value: 'center',
            label: 'center'
          },
          {
            value: 'left',
            label: 'left'
          },
          {
            value: 'right',
            label: 'right'
          }
        ]
      }
    ]

    const actHandler = {
      add() {
        state.dataModel.push(methods.genNewColumn())
      },
      edit(id) {
        const currentItem = state.dataModel.find((item) => item._id === id)
        $FormDialogServer({
          title: '编辑列表项数据',
          formModel: currentItem,
          formFields: editFields,
          onConfirm(formData) {
            const item = state.dataModel.find((item) => item._id === formData._id)
            Object.assign(item, { ...formData })
          }
        })
      },
      delete(id) {
        const idx = state.dataModel.findIndex((item) => item._id === id)
        state.dataModel.splice(idx, 1)
      },
      changeOrder(id, step) {
        const item = state.dataModel.find((item) => item._id === id)
        item.order += step
      }
    }
    watch(() => state.dataModel, methods.updateChange, { deep: true })
    return () => (
      <div class="column-input">
        {state.dataModel.map(({ _id, label }, idx) => (
          <div class="column-input-item" key={_id}>
            <div class="column-input-item-info">
              <span class="column-input-item-info-label">{`列${idx + 1}:`}</span>
              <span class="column-input-item-info-content">{label}</span>
            </div>
            <div class="column-input-item-action">
              <n-button
                class="action-btn"
                text
                size="tiny"
                type="tertiary"
                onClick={() => actHandler.edit(_id)}
              >
                {{
                  icon: () => (
                    <n-icon>
                      <EditOutlined />
                    </n-icon>
                  )
                }}
              </n-button>
              {/* {!!idx && (
                <n-button
                  class="action-btn"
                  text
                  size="tiny"
                  type="tertiary"
                  onClick={() => actHandler.changeOrder(_id, -1)}
                >
                  {{
                    icon: () => (
                      <n-icon>
                        <arrow-up />
                      </n-icon>
                    )
                  }}
                </n-button>
              )} */}
              {/* {idx + 1 !== dataModel.value.length && (
                <n-button
                  class="action-btn"
                  text
                  size="tiny"
                  type="tertiary"
                  onClick={() => actHandler.changeOrder(_id, 1)}
                >
                  {{
                    icon: () => (
                      <n-icon>
                        <arrow-down />
                      </n-icon>
                    )
                  }}
                </n-button>
              )} */}
              <n-button
                class="action-btn"
                text
                size="tiny"
                type="tertiary"
                onClick={() => actHandler.delete(_id)}
              >
                {{
                  icon: () => (
                    <n-icon>
                      <DeleteOutlined />
                    </n-icon>
                  )
                }}
              </n-button>
            </div>
          </div>
        ))}
        <div class="column-input-action">
          <n-button size="small" onClick={actHandler.add}>
            新增
          </n-button>
        </div>
      </div>
    )
  }
})
